import { Fragment } from "react";
import { Link, useParams } from "react-router";
import { StatusPill } from "./StatusPill";

export interface RoutingConnector {
  id: string;
  name: string;
}

export function ThroughConnector({
  connectors,
  linked = false,
}: {
  connectors: RoutingConnector[];
  linked?: boolean;
}) {
  const { orgId } = useParams();

  return (
    <span className="inline-flex flex-col items-start gap-1">
      <StatusPill variant="routed">Through connector</StatusPill>
      <span className="text-xs text-foreground/70">
        via{" "}
        {connectors.map((connector, index) => (
          <Fragment key={connector.id}>
            {index > 0 && ", "}
            {linked && orgId ? (
              <Link
                to={`/${orgId}/networking/connectors/${connector.id}`}
                className="text-accent hover:underline"
              >
                {connector.name}
              </Link>
            ) : (
              connector.name
            )}
          </Fragment>
        ))}
      </span>
    </span>
  );
}
